import { cleanFullAddress, type PropertyAddress } from '@urbanx/agx-ui-components';
import { AuthContext } from '@urbanx/agx.auth.client';
import { AgxSpacer, Icon_AlertCircleOutline } from '@urbanx/agx.ui-components2';
import { MenuTitles } from 'constants/menu';
import { useSelectedAgency, useSelectedCampaign } from 'hooks';
import { ContentLayout, PageLayout } from 'layout';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { AutomationErrors } from './AutomationErrors';
import './automationErrors.scss';

const AutomationErrorsPage = () => {
  const { campaignId } = useParams();
  const { userAccount } = useContext(AuthContext);
  const { agency } = useSelectedAgency();
  const { campaign } = useSelectedCampaign();
  const staffName = [userAccount?.firstName, userAccount?.lastName].filter(Boolean).join(' ');

  return (
    <PageLayout
      agentName={staffName}
      primaryPageTitle={campaignId ? (agency?.name ?? '') : 'Error Log'}
      currentPageTitle={
        campaignId
          ? `Campaigns / ${cleanFullAddress(campaign?.address as PropertyAddress)}`
          : undefined
      }
      isCampaignsSection={!!campaignId}
      hideSearch
      pageIcon={
        !campaignId ? (
          <AgxSpacer
            contentAlignment="center"
            contentJustification="center"
            style={{
              width: 48,
              height: 48,
              borderRadius: 24,
              background: 'rgba(var(--color-black-main))',
            }}
          >
            <Icon_AlertCircleOutline type="Other" color="var(--fg-white)" width={28} height={28} />
          </AgxSpacer>
        ) : undefined
      }
    >
      {campaignId ? (
        <ContentLayout hasSecondaryMenu={false} isCampaigns secondaryActiveMenu={MenuTitles.ERRORS}>
          <AutomationErrors campaignId={campaignId} />
        </ContentLayout>
      ) : (
        <AutomationErrors />
      )}
    </PageLayout>
  );
};

export default AutomationErrorsPage;
